import styled from '@emotion/styled';

import Button from 'components/field/Button';

import { Breakpoints } from 'utils/const.styles';

import Icon from '../Icon';

export const FilterButton = styled(Button)`
	&.greyOutline {
		background: transparent;
		border-color: var(--border-color);
		color: var(--content-2);

		:not(.disabled):hover {
			background: var(--blue);
			color: var(--white);
			border-color: var(--blue);

			.button-text,
			.button-icon {
				color: var(--white);
			}
		}
	}
`;

export const Divider = styled.div`
	border-bottom: 1px solid var(--border-color);
	margin: 2rem 0;
`;

export const TextContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 33rem;
	@media ${Breakpoints.tablet} {
		width: 70%;
	}
`;

export const WidgetContainer = styled.div`
	display: flex;
	flex-direction: row;
	gap: 1rem;
	align-items: center;
	margin-bottom: var(--margin-3);
	border-radius: var(--small-border-radius);
	padding: var(--padding-3);
	justify-content: space-between;
	width: 100%;
	background: var(--background-3);
`;

export const SearchWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	margin-top: var(--margin-4);
	gap: 1rem;
	@media ${Breakpoints.tablet} {
		flex-direction: column;
	}
`;

export const FilterWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	@media ${Breakpoints.tablet} {
		justify-content: flex-start;
	}
`;

export const SettingsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	@media ${Breakpoints.tablet} {
		padding: var(--padding-4);
	}
`;

export const WidgetPreview = styled.div`
	padding: var(--padding-3);
	border-radius: var(--medium-border-radius);
	background: ${({ backgroundColor }) => backgroundColor || 'var(--border-color)'};
	color: var(--alwaysWhiteColor);

	@media ${Breakpoints.tablet} {
		padding: var(--padding-2);
	}
`;

export const ChartPreviewIcon = styled(Icon)`
	line-height: unset;
`;
